import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=daad30ba&scoped=true&"
import script from "./MenuAdmin.vue?vue&type=script&lang=js&"
export * from "./MenuAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=daad30ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daad30ba",
  null
  
)

export default component.exports